import React, { useEffect, useState } from 'react';
import arrow_enter from '../../../images/play.png'
import Button from '../Button';

import './StartButton.css';

const StartButton = (props) => {
    let cl = props.className ? props.className : ""
    cl += "start-button"
    return <Button {...props} pill className={cl} > 
        <div className="start" >
            <img src={arrow_enter} />
        </div>
    </Button>};

export default StartButton;